import { WORDPRESS_API_JSON } from "shared/constants/api";

/**
 * Pobiera najnowsze wpisy z podanej kategorii WordPress.
 */
export const getLatestWordPressAnnouncements = async ({
  limit = 3,
  signal,
  categorySlug = "ogloszenia",
} = {}) => {
  const categoryResponse = await fetch(
    `${WORDPRESS_API_JSON}/categories?slug=${categorySlug}`,
    { signal }
  );

  if (!categoryResponse.ok) {
    throw new Error(
      `Nie udało się pobrać kategorii '${categorySlug}'.`
    );
  }

  const [category] = await categoryResponse.json();

  if (!category) {
    return [];
  }

  const postsResponse = await fetch(
    `${WORDPRESS_API_JSON}/posts?categories=${category.id}&per_page=${limit}&orderby=date&order=desc&_embed=1`,
    { signal }
  );

  if (!postsResponse.ok) {
    throw new Error(
      `Nie udało się pobrać wpisów z kategorii '${categorySlug}'.`
    );
  }

  return postsResponse.json();
};

export const getWordPressAnnouncementById = async ({
  postId,
  signal,
}) => {
  const response = await fetch(
    `${WORDPRESS_API_JSON}/posts/${postId}?_embed=1`,
    { signal }
  );

  if (!response.ok) {
    throw new Error("Nie udało się pobrać ogłoszenia.");
  }

  return response.json();
};